import React from 'react';
import { Horizontal, Vertical } from 'packages/radiant-react/layout';
import styles from './styles.module.scss';
import { Colors, Typography } from 'packages/radiant-react/typography';
import { Icon, IconColor, IconID } from 'packages/radiant-react/icon';

interface ComponentDropdownProps {
  id: string;
  children: any;
  title: string;
  setCurrentIndex: (index: string[]) => void;
  currentIndex: string[];
}

const ComponentDropdown = ({
  children,
  title = 'Test',
  setCurrentIndex,
  id,
  currentIndex,
}: ComponentDropdownProps) => {
  const isChecked = currentIndex.includes(title);

  const handleCheckboxChange = (title: string) => {
    if (currentIndex.includes(title)) {
      setCurrentIndex(currentIndex.filter((index: string) => index !== title));
    } else {
      setCurrentIndex([...currentIndex, title]);
    }
  };

  return (
    <Vertical checked={isChecked} className={styles.dropdownContainer}>
      <Horizontal
        className={styles.dropdownTitleContainer}
        onClick={() => handleCheckboxChange(title)}
      >
        <Typography variant="p" color={Colors.base} className={styles.dropdownTitle}>
          {title}
        </Typography>
        <Icon id={isChecked ? IconID.CHEVRON_UP : IconID.CHEVRON_DOWN} color={IconColor.DARKGRAY} />
      </Horizontal>
      {isChecked && <Vertical className={styles.dropdownSlide}>{children}</Vertical>}
    </Vertical>
  );
};

export default ComponentDropdown;
